// Currencies offered by the 匯率算算 converter on the add-payment page —
// TWD plus the major world / common travel currencies (Asia-travel first,
// then the big Western & global currencies).
// The converter filters out the account book's own currency at render time,
// so e.g. a JPY book shows TWD/USD/KRW/... but not JPY.
//
// `code` must match the keys returned by GET /api/v1/exchange_rates
// (kept in sync with ExchangeRateService::WHITELIST on the backend).
export const CONVERTIBLE_CURRENCIES = [
  { code: 'TWD', flag: '🇹🇼', label: '台幣' },
  { code: 'JPY', flag: '🇯🇵', label: '日圓' },
  { code: 'KRW', flag: '🇰🇷', label: '韓元' },
  { code: 'HKD', flag: '🇭🇰', label: '港幣' },
  { code: 'USD', flag: '🇺🇸', label: '美元' },
  { code: 'CNY', flag: '🇨🇳', label: '人民幣' },
  { code: 'THB', flag: '🇹🇭', label: '泰銖' },
  { code: 'SGD', flag: '🇸🇬', label: '新加坡幣' },
  { code: 'MYR', flag: '🇲🇾', label: '馬來幣' },
  { code: 'VND', flag: '🇻🇳', label: '越南盾' },
  { code: 'PHP', flag: '🇵🇭', label: '菲律賓披索' },
  { code: 'IDR', flag: '🇮🇩', label: '印尼盾' },
  { code: 'MOP', flag: '🇲🇴', label: '澳門幣' },
  { code: 'EUR', flag: '🇪🇺', label: '歐元' },
  { code: 'GBP', flag: '🇬🇧', label: '英鎊' },
  { code: 'AUD', flag: '🇦🇺', label: '澳幣' },
  { code: 'NZD', flag: '🇳🇿', label: '紐元' },
  { code: 'CAD', flag: '🇨🇦', label: '加幣' },
  { code: 'CHF', flag: '🇨🇭', label: '瑞士法郎' },
  { code: 'INR', flag: '🇮🇳', label: '印度盧比' },
  { code: 'AED', flag: '🇦🇪', label: '阿聯酋迪拉姆' },
  { code: 'SAR', flag: '🇸🇦', label: '沙烏地里亞爾' },
  { code: 'TRY', flag: '🇹🇷', label: '土耳其里拉' },
  { code: 'ZAR', flag: '🇿🇦', label: '南非蘭特' },
  { code: 'MXN', flag: '🇲🇽', label: '墨西哥披索' },
  { code: 'BRL', flag: '🇧🇷', label: '巴西雷亞爾' },
  { code: 'SEK', flag: '🇸🇪', label: '瑞典克朗' },
  { code: 'NOK', flag: '🇳🇴', label: '挪威克朗' },
  { code: 'DKK', flag: '🇩🇰', label: '丹麥克朗' },
  { code: 'PLN', flag: '🇵🇱', label: '波蘭茲羅提' },
  { code: 'CZK', flag: '🇨🇿', label: '捷克克朗' },
  { code: 'RUB', flag: '🇷🇺', label: '俄羅斯盧布' },
  { code: 'ILS', flag: '🇮🇱', label: '以色列謝克爾' },
  { code: 'HUF', flag: '🇭🇺', label: '匈牙利福林' },
  { code: 'RON', flag: '🇷🇴', label: '羅馬尼亞列伊' },
  { code: 'BGN', flag: '🇧🇬', label: '保加利亞列弗' },
  { code: 'ISK', flag: '🇮🇸', label: '冰島克朗' },
  { code: 'UAH', flag: '🇺🇦', label: '烏克蘭格里夫納' },
  { code: 'QAR', flag: '🇶🇦', label: '卡達里亞爾' },
  { code: 'KWD', flag: '🇰🇼', label: '科威特第納爾' },
  { code: 'BHD', flag: '🇧🇭', label: '巴林第納爾' },
  { code: 'OMR', flag: '🇴🇲', label: '阿曼里亞爾' },
  { code: 'EGP', flag: '🇪🇬', label: '埃及鎊' },
  { code: 'MAD', flag: '🇲🇦', label: '摩洛哥迪拉姆' },
  { code: 'PKR', flag: '🇵🇰', label: '巴基斯坦盧比' },
  { code: 'BDT', flag: '🇧🇩', label: '孟加拉塔卡' },
  { code: 'LKR', flag: '🇱🇰', label: '斯里蘭卡盧比' },
  { code: 'NPR', flag: '🇳🇵', label: '尼泊爾盧比' },
  { code: 'KHR', flag: '🇰🇭', label: '柬埔寨瑞爾' },
  { code: 'LAK', flag: '🇱🇦', label: '寮國基普' },
  { code: 'MMK', flag: '🇲🇲', label: '緬甸元' },
  { code: 'BND', flag: '🇧🇳', label: '汶萊幣' },
  { code: 'MNT', flag: '🇲🇳', label: '蒙古圖格里克' },
  { code: 'KZT', flag: '🇰🇿', label: '哈薩克堅戈' },
  { code: 'NGN', flag: '🇳🇬', label: '奈及利亞奈拉' },
  { code: 'KES', flag: '🇰🇪', label: '肯亞先令' },
  { code: 'CLP', flag: '🇨🇱', label: '智利披索' },
  { code: 'COP', flag: '🇨🇴', label: '哥倫比亞披索' },
  { code: 'ARS', flag: '🇦🇷', label: '阿根廷披索' },
  { code: 'PEN', flag: '🇵🇪', label: '秘魯索爾' },
]
